import React, { useState } from 'react';
import { Phone, X, MessageCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { RevealContact } from '../RevealContact';
import { RAQ_CONTACTS } from '../../lib/contacts';
import { motion, AnimatePresence } from 'framer-motion';

export const Support247Button = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-40">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 10, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10, scale: 0.95 }}
            transition={{ duration: 0.15 }}
            className="absolute bottom-16 right-0 w-80 bg-white border border-gray-200 rounded-xl shadow-2xl p-4 space-y-3"
            data-testid="support-247-panel"
          >
            <div className="flex items-start justify-between">
              <div>
                <p className="text-black font-semibold">Support 24/7</p>
                <p className="text-xs text-gray-500">Disponible jour et nuit</p>
              </div>
              <button
                onClick={() => setOpen(false)}
                className="text-gray-400 hover:text-black"
                aria-label="Fermer"
                data-testid="support-247-close"
              >
                <X className="h-4 w-4" />
              </button>
            </div>

            <RevealContact
              type="phone"
              label="Téléphone"
              value={RAQ_CONTACTS.phone}
              testId="support-247-phone"
            />
            <RevealContact
              type="email"
              label="Courriel support"
              value={RAQ_CONTACTS.emails.support}
              testId="support-247-email"
            />
          </motion.div>
        )}
      </AnimatePresence>

      <Button
        onClick={() => setOpen((v) => !v)}
        className="bg-black text-white hover:bg-gray-800 rounded-full h-14 px-6 shadow-lg border border-gray-700"
        data-testid="support-247-trigger"
      >
        {open ? <MessageCircle className="h-5 w-5 mr-2" /> : <Phone className="h-5 w-5 mr-2" />}
        <span className="font-semibold">Support 24/7</span>
      </Button>
    </div>
  );
};

export default Support247Button;
